export interface Notification {
  id: string;
  userId: string;
  title: string;
  message: string;
  timestamp: string;
  isRead: boolean;
  type: NotificationType;
  relatedEntityId?: string; // ID of the related entity (offer, request, etc.)
  actionUrl?: string;
}

export enum NotificationType {
  TIMELINE_UPDATE = 'timeline_update',
  MEETING_ANNOUNCEMENT = 'meeting_announcement',
  MARKETPLACE_MATCH = 'marketplace_match',
  INBOX_MESSAGE = 'inbox_message',
  MATCH_FOUND = 'match_found',
  MESSAGE_RECEIVED = 'message_received'
}

export interface Message {
  id: string;
  senderId: string;
  recipientId: string;
  content: string;
  timestamp: string;
  isRead: boolean;
  relatedEntityId?: string; // ID of the related entity (offer, request, etc.)
}

export interface Conversation {
  id: string;
  participants: string[]; // User IDs
  messages: Message[];
  lastMessageTimestamp: string;
} 